import React, { Children, useEffect, useRef, useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Swal from "sweetalert2";
import { MenuIcon, MenuAlt3Icon } from "@heroicons/react/outline";
import LOCAL_KEYS, {
  parseLocalStorageJSON,
} from "../../../helpers/Localstorage";
import { endSession } from "../../../helpers/sessionTimeout";
import { useDispatch, useSelector } from "react-redux";
import { toggleMenubar } from "../../../Redux/AppconifgStage/AppconfigActionCreator";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { red } from "@mui/material/colors";
import { MdClose } from "react-icons/md";
import { requestEventsNotificationsAction, setResetStateEventsNotifications } from "../../../Redux/EventState/EventActionCreator";
import moment from "moment";
import Loader from "../../Loader";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const userDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);
  const profileRef = useRef(null);
  const notificationRef = useRef(null);
  const appConfigState = useSelector((state) => state.AppConfigReducer);
  const eventsListReducer = useSelector((state) => state.EventsNotificationsListReducer);
  const { expandMenuBar } = appConfigState;
  const dispatch = useDispatch();
  const hasFetchedEvents = useRef(false);
  const [stableCount, setStableCount] = useState(0);

  const events = eventsListReducer?.response;

  useEffect(() => {
    if (events?.totalEvents !== undefined) {
      setStableCount(events.totalEvents);
    }
  }, [events?.totalEvents]);
  
  const menu = [
    {
      name: "Profile",
      path: "/profile",
      icon: <PermIdentityIcon fontSize="medium" />,
      children: false,
    },
    {
      name: "Settings",
      path: "/updatePassword",
      icon: <SettingsIcon fontSize="medium" />,
    },
    {
      name: "Logout",
      path: "logout",
      icon: <LogoutIcon fontSize="medium" sx={{ color: red[500] }} />,
    },
  ];

  const AdminNavigation = [
    { name: "Dashboard", href: "/" },
    {
      name: "Timesheet",
      href: "/timesheets",
    },
    {
      name: "Timesheets Yet To Be Approved",
      href: "/pendingTimesheets",
    },
    {
      name: "Timesheets To Be Invoiced",
      href: "/tobeinvoiced",
    },
    {
      name: "Rejected Timesheets",
      href: "/rejectedTimesheets",
    },
    {
      name: "To Be Invoiced",
      href: "/tobeinvoiced",
    },
    {
      name: "Payment Pending",
      href: "/pendingInvoices",
    }, 
    { 
      name: "Employee Management",
      href: "/manageemployee",
    },
    {
      name: "Manage Employee",
      href: "/addemployee",
    },
    {
      name: "Employee Status",
      href: "/addemployeestatus/",
    },
    { name: "Clients List", href: "/addclient" },
    {
      name: "Projects List",
      href: "/addproject",
    },
    {
      name: "Reports",
      href: "/reports",
    },
    {
      name: "Reports-Projects",
      href: "/projects",
    },
    {
      name:"Reports-Budget",
      href:"/budget"
    },
    {
      name: "Documents",
      href: "/documents",
    },
    {
      name: "Invoices",
      href: "/invoices"
    },
    {
      name: "TimeSheets",
      href: "/emptimesheets",
    },
    {
      name: "Pending Time Off Requests",
      href: "/timeoff",
    },

    {
      name: "Approved Time Off Requests",
      href: "/approvedtimeoff",
    },
    {
      name: "Rejected Time Off Requests",
      href: "/rejectedtimeoff",
    },
    // {
    //   name: "Employees Events",
    //   href: "/employeeEvents",
    // },
    {
      name: "Events",
      href: "/events",
    },
    {
      name: "Birthdays",
      href: "/birthdays",
    },
    {
      name: "Anniversaries",
      href: "/anniversaries",
    },
    {
      name: "Quotes",
      href: "/quotes",
    },
    {
      name: "Impersonate",
      href: "/impersonate-user",
    },
    {
      name:"Admin Preferences",
      href:"/adminPreferences"
    }

  ];

  const getPageTitle = () => {
    const matchedPage = AdminNavigation.find(
      (item) => item.href === location.pathname
    );

    if (matchedPage) {
      return matchedPage.name;
    }

    if (location.pathname.startsWith("/editemployee/")) {
      return "Edit Employee";
    }

    if (location.pathname.startsWith("/addemployeestatus/")) {
      return "Employee Status";
    }
    if (location.pathname.startsWith("/profile")) {
      return "Profile"
    }
    if (location.pathname.startsWith("/updatePassword")) {
      return "UpdatePassword"
    }
    if (location.pathname.startsWith("/invoices")){
      return "Invoices";
    }
    if (location.pathname.startsWith("/events")){
      return "Events";
    }
    return "Unknown Page"; // Fallback title if no match is found
  };
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure you want to Logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3674B5",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Logout!",
      backdrop: `rgba(0, 0, 0, 0.5)`,
    }).then((result) => {
      if (result.isConfirmed) {
        endSession();
      }
    });
  };

  // Handle navigation on clicking dropdown options
  const handleNavigation = (path) => {
    if (path === "logout") {
      handleLogout();
    } else {
      navigate(path);
      setDropdownOpen(false);
    }
  };

  const handleDropdown = () => {};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setNotificationDrawerOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   if (notificationDrawerOpen && !eventsListReducer?.response?.events) {
  //     dispatch(setResetStateEvents());
  //     dispatch(requestEventsAction({
  //       page: 0,
  //       size: 10,
  //     }));
  //   }
  // }, [notificationDrawerOpen, eventsListReducer?.response?.events]);

  // useEffect(() => {
  //   if (userDetails && !eventsListReducer?.response?.events) {
  //     dispatch(setResetStateEvents());
  //     dispatch(requestEventsAction({
  //       page: 0,
  //       size: 10,
  //     }));
  //   }
  // }, [userDetails, eventsListReducer?.response?.events]);

  useEffect(() => {
    if (notificationDrawerOpen && !hasFetchedEvents.current) {
      hasFetchedEvents.current = true;
      dispatch(setResetStateEventsNotifications());
      dispatch(requestEventsNotificationsAction());
    }
  }, [notificationDrawerOpen]);
  
  useEffect(() => {
    if (userDetails && !hasFetchedEvents.current) {
      hasFetchedEvents.current = true;
      dispatch(setResetStateEventsNotifications());
      dispatch(requestEventsNotificationsAction());
    }
  }, [userDetails]);


  return (
    <div className="h-20 px-3 flex items-center justify-between border-b-4 border-gray-300">
      <Loader isLoading={eventsListReducer?.loading}/>
      <div className="flex items-center space-x-4 md:space-x-0">
        {/* Toggle button for Sidebar on small screens */}
        <button
          onClick={() => dispatch(toggleMenubar(!expandMenuBar))}
          className="h-10 w-10 py-2 pl-2 sm:left-4 cursor-pointer text-fontPrimary transition-colors duration-200 sm:hidden"
        >
          {expandMenuBar ? <MdClose size={20} /> : <MenuIcon size={20} />}
        </button>

        <button
          onClick={() => dispatch(toggleMenubar(!expandMenuBar))}
          className="h-10 w-10 py-3 cursor-pointer text-fontPrimary transition-colors duration-200 hidden sm:block"
        >
          <MenuIcon size={20}/>
        </button>

        <h3 className="text-lg font-normal pt-4 pl-3 text-fontPrimary flex-grow text-center">
          {getPageTitle()}
        </h3>
      </div>

      <div className="flex items-center space-x-4">
        {/* Notification Icon */}
        <div className="relative" ref={notificationRef}>
          <button
            onClick={() => setNotificationDrawerOpen(!notificationDrawerOpen)}
            className="p-2 text-primary hover:text-primaryDark focus:outline-none bg-gray-300 rounded-full relative"
          >
            <NotificationsIcon />
            {userDetails && stableCount > 0 && (
              <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full ring-2 ring-white">
                {stableCount}
              </span>
            )}
          </button>

          {/* Notification Drawer */}
          <AnimatePresence>
            {notificationDrawerOpen && (
              <motion.div
                initial={{ rotateY: 90, opacity: 0 }}
                animate={{ rotateY: 0, opacity: 1 }}
                exit={{ rotateY: 90, opacity: 0 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 top-10 w-80 bg-white rounded-md shadow-lg z-20 border border-gray-200"
              >
                <div className="p-4 border-b border-gray-200">
                  <h3 className="text-lg font-semibold text-gray-900">
                    Upcoming Events
                  </h3>
                </div>
                <div className="max-h-96 overflow-y-auto">
                  {eventsListReducer?.loading ? (
                    <div className="p-4 text-center">Loading...</div>
                  ) : events ? (
                    <>
                      {events.birthdays && events.birthdays.length > 0 && (
                        <div>
                          <div className="px-4 py-2 bg-gray-50 text-medium font-bold text-gray-950">
                            Birthdays
                          </div>
                          {events.birthdays.map((event, index) => (
                            <div
                              key={`birthday-${index}`}
                              className="p-4 border-b border-gray-200 hover:bg-gray-50 cursor-pointer"
                              onClick={() => {
                                navigate("/birthdays");
                                setNotificationDrawerOpen(false);
                              }}
                            >
                              <div className="flex justify-between items-start">
                                <div>
                                  <p className="text-sm font-medium text-gray-900">{event.name}</p>
                                  <p className="text-xs text-gray-500">{event.eventType}</p>
                                </div>
                                <span className="text-xs text-gray-500">
                                  {moment(event.date).format("MMM D, YYYY")}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      {events.anniversaries && events.anniversaries.length > 0 && (
                        <div>
                          <div className="px-4 py-2 bg-gray-50 text-medium font-bold text-gray-950">
                            Work Anniversaries
                          </div>
                          {events.anniversaries.map((event, index) => (
                            <div
                              key={`anniversary-${index}`}
                              className="p-4 border-b border-gray-200 hover:bg-gray-50 cursor-pointer"
                              onClick={() => {
                                navigate("/anniversaries");
                                setNotificationDrawerOpen(false);
                              }}
                            >
                              <div className="flex justify-between items-start">
                                <div>
                                  <p className="text-sm font-medium text-gray-900">{event.name}</p>
                                  <p className="text-xs text-gray-500">{event.eventType}</p>
                                </div>
                                <span className="text-xs text-gray-500">
                                  {moment(event.date).format("MMM D, YYYY")}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      {(!events.birthdays || events.birthdays.length === 0) && 
                       (!events.anniversaries || events.anniversaries.length === 0) && (
                        <div className="p-4 text-center text-gray-500">No upcoming events</div>
                      )}
                    </>
                  ) : (
                    <div className="p-4 text-center text-gray-500">No events found</div>
                  )}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* Profile Icon */}
        <div
          onClick={() => setDropdownOpen(!dropdownOpen)}
          className="h-11 w-11 flex
            focus:ring-4 focus:ring-gray-50 bg-primary text-white
            dark:focus:ring-gray-600  cursor-pointer  
            hover:shadow-md hover:shadow-gray-400 md:me-0 hover:transition-all hover:border-gray hover:border-4
            rounded-full shadow-md justify-center items-center"
        >
          <p className="text-sm font-normal ">
            {userDetails?.firstName.split("")[0]?.toUpperCase()}
            {userDetails?.lastName.split("")[0]?.toUpperCase()}
          </p>
        </div>
      </div>

      <AnimatePresence>
        {dropdownOpen && (
          <motion.div
            ref={profileRef}
            initial={{ rotateY: 90, opacity: 0 }}
            animate={{ rotateY: 0, opacity: 1 }}
            exit={{ rotateY: 90, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="absolute right-0 top-16 w-64 bg-gray-100 rounded-md text-gray-900 shadow-lg z-20"
          >
            {/* <p className="px-4 py-4 text-sm font-semibold border-b">Account</p> */}
            <div className="flex items-center px-4 py-2 mb-2">
              <div className="h-10 w-10 flex bg-primary text-white cursor-pointer rounded-full shadow-md justify-center items-center">
                <p className="text-lg font-normal">{`${userDetails.firstName[0]?.toUpperCase()}${userDetails.lastName[0]?.toUpperCase()}`}</p>
              </div>
              <span className="ml-2">
                <p className="text-sm font-normal">{`${userDetails.firstName} ${userDetails.lastName}`}</p>
                <p className="text-xs font-normal text-gray-600">
                  {userDetails.email}
                </p>
              </span>
            </div>
            <div className="px-5 border-2 border-gray-300"></div>
            {menu.map((item, index) => (
              <button
                key={index}
                onClick={() => handleNavigation(item.path)}
                className={`block px-4 py-3 text-sm ${
                  item.path === "logout"
                    ? "hover:bg-secondaryDark hover:text-white"
                    : "hover:bg-gray-300 hover:text-white"
                } transition-colors duration-200 w-full text-left`}
              >
                <span className="flex items-center justify-start gap-6">
                  {item.icon}
                  {item.name}
                </span>
              </button>
            ))}
            <div className="py-1"></div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Header;